import {
  ADD_WEEKLY_SCHEDULE,
  GET_ALL_SCHEDULE,
  UPDATE_ONE_WEEKLY_SCHEDULE,
  DELETE_ONE_SCHEDULE,
  GET_ONE_SCHEDULE,
} from "../../actions/types";

const initialState = {
  weeklySchedule: [],
  oneWeeklySchedule: {},
};

const usersReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_WEEKLY_SCHEDULE:
      return {
        ...state,
        weeklySchedule: [...state.weeklySchedule, action.payload],
      };
    case GET_ALL_SCHEDULE:
      //  console.log("GET_ALL_SCHEDULE",GET_ALL_SCHEDULE);
      return {
        ...state,
        weeklySchedule: action.payload,
      };
    case UPDATE_ONE_WEEKLY_SCHEDULE:
      return {
        ...state,
        weeklySchedule: state.weeklySchedule.map((el) =>
          el._id === action.payload._id
            ? {
                ...el,
                schedules: action.payload.schedules,
                userId: action.payload.userId,
                isActive: action.payload.isActive,
              }
            : el
        ),
      };
        case DELETE_ONE_SCHEDULE:
      return {
        ...state,
        weeklySchedule: state.weeklySchedule.filter((el) =>el._id !== action.payload),
      };
         case GET_ONE_SCHEDULE:
      return {
        ...state,
        oneWeeklySchedule: action.payload,
      };

    default:
      return state;
  }
};
export default usersReducer;
